import { SalesChannel } from "./types";

export const SALES_CHANNELS: SalesChannel[] = ["PHONE", "BRANCH", "ONLINE", "MOBILE_APP"];
